/* eslint-disable eqeqeq */
import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import FontFa from "../../../../../components/fontFa/fontFa";
import { useEmployee } from "../../../../../hook";
import { useGetDetailRequests } from "../hooks";
import { requestStatus } from "../../../../../constants";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { Skeleton } from "antd";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { isNoiBai } from "../utils";
import { getEmployeeDetail } from "../../summary-employee-request/utils/get-employee-detail";
import { useSelector } from "../../../../../store/store";

export const ExportProgress: FC = () => {
  const { data: employees, isLoading: isLoadingEmployees } = useEmployee();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const { data: detail, isLoading: isLoadingDetailRequest }: any =
    useGetDetailRequests();

  if (isLoadingEmployees || isLoadingDetailRequest) return <Skeleton />;

  const getStatus = (status: string) => {
    if (status == requestStatus.approved) return requestStatus.approved;
    if (status == requestStatus.rejected) return requestStatus.rejected;
    return requestStatus.submitted;
  };

  return (
    <Box title="Quy trình duyệt">
      <div className="TimelineBox horizontal mdHorizontal mdSmall">
        <div className="item">
          <div className="step approved">
            <FontFa name="faCheck" />
          </div>
          <div className="content">
            <div className="rank">
              <h6>Khởi tạo</h6>
            </div>
            <div className="title">{detail?.createdBy?.user?.displayName}</div>
            <div className="title">{detail?.createdBy?.user?.email} </div>
            <div className="time">
              {`Ngày tạo: ${getDDMMYYYFormat(
                detail?.createdDateTime
              )} - ${getHHmmFormat(detail?.createdDateTime)}`}
            </div>
          </div>
        </div>

        {/*BƯỚC 1 */}
        <div className="item">
          {getStatus(detail?.fields?.eApprovedStatus) ===
            requestStatus.approved && (
            <div className={`step approved`}>
              <FontFa name="faCheck" />
            </div>
          )}

          {getStatus(detail?.fields?.eApprovedStatus) ===
            requestStatus.rejected && (
            <div className={`step rejected`}>
           <FontFa name="faBan" />
            </div>
          )}

          {getStatus(detail?.fields?.eApprovedStatus) ===
            requestStatus.submitted && (
            <div className={`step waiting`}>
              <FontFa name="faCheck" />
            </div>
          )}

          <div className="content">
            <div className="rank">
              <h6>
                {isNoiBai(detail?.fields?.eDepartment)
                  ? "Trưởng phòng KHHC"
                  : "Thủ trưởng cơ quan đơn vị"}
              </h6>
            </div>
            <div className="title">
              {
                getEmployeeDetail(
                  detail?.fields?.eApprovedBy,
                  employees,
                  softwares
                )?.[0]?.Title
              }
            </div>
            <div className="title">
              {
                getEmployeeDetail(
                  detail?.fields?.eApprovedBy,
                  employees,
                  softwares
                )?.[0]?.eMail
              }
            </div>
            {(detail?.fields?.eApprovedStatus === requestStatus.approved ||
              detail?.fields?.eApprovedStatus === requestStatus.rejected) && (
              <div className="time">{`Ngày duyệt: ${getDDMMYYYFormat(
                detail?.fields?.eApprovedDate
              )} - ${getHHmmFormat(detail?.fields?.eApprovedDate)}`}</div>
            )}
          </div>
        </div>

        {/*BƯỚC 2 */}
        <div className="item">
          {getStatus(detail?.fields?.eApprovedByITLeadStatus) ===
            requestStatus.approved && (
            <div className={`step approved`}>
              <FontFa name="faCheck" />
            </div>
          )}

          {getStatus(detail?.fields?.eApprovedByITLeadStatus) ===
            requestStatus.rejected && (
            <div className={`step rejected`}>
              <FontFa name="faBan" />
            </div>
          )}

          {getStatus(detail?.fields?.eApprovedByITLeadStatus) ===
            requestStatus.submitted && (
            <div className={`step waiting`}>
              <FontFa name="faCheck" />
            </div>
          )}

          <div className="content">
            <div className="rank">
              <h6>
                {isNoiBai(detail?.fields?.eDepartment)
                  ? "Giám đốc chi nhánh"
                  : "Bộ phận đào tạo TCNL"}
              </h6>
            </div>
            <div className="title">
              {
                getEmployeeDetail(
                  detail?.fields?.eApprovedByITLead,
                  employees,
                  softwares
                )?.[0]?.Title
              }
            </div>
            <div className="title">
              {
                getEmployeeDetail(
                  detail?.fields?.eApprovedByITLead,
                  employees,
                  softwares
                )?.[0]?.eMail
              }
            </div>
            {(detail?.fields?.eApprovedByITLeadStatus ===
              requestStatus.approved ||
              detail?.fields?.eApprovedByITLeadStatus ===
                requestStatus.rejected) &&
              detail?.fields?.eApprovedDate && (
                <div className="time">{`Ngày duyệt: ${getDDMMYYYFormat(
                  detail?.fields?.eApprovedDate
                )} - ${getHHmmFormat(detail?.fields?.eApprovedDate)}`}</div>
              )}
          </div>
        </div>

        {/*BƯỚC 3 */}
        {!isNoiBai(detail?.fields?.eDepartment) && (
          <div className="item">
            {getStatus(detail?.fields?.eApprovedByITHeadStatus) ===
              requestStatus.approved && (
              <div className={`step approved`}>
                <FontFa name="faCheck" />
              </div>
            )}

            {getStatus(detail?.fields?.eApprovedByITHeadStatus) ===
              requestStatus.rejected && (
              <div className={`step rejected`}>
                <FontFa name="faBan" />
              </div>
            )}

            {getStatus(detail?.fields?.eApprovedByITHeadStatus) ===
              requestStatus.submitted && (
              <div className={`step waiting`}>
                <FontFa name="faCheck" />
              </div>
            )}

            <div className="content">
              <div className="rank">
                <h6>Trưởng phòng TCNL</h6>
              </div>
              <div className="title">
                {
                  getEmployeeDetail(
                    detail?.fields?.eApprovedByITHead,
                    employees,
                    softwares
                  )?.[0]?.Title
                }
              </div>
              <div className="title">
                {
                  getEmployeeDetail(
                    detail?.fields?.eApprovedByITHead,
                    employees,
                    softwares
                  )?.[0]?.eMail
                }
              </div>
              {(detail?.fields?.eApprovedByITHeadStatus ===
                requestStatus.approved ||
                detail?.fields?.eApprovedByITHeadStatus ===
                  requestStatus.rejected) &&
                detail?.fields?.eApprovedByITHeadDate && (
                  <div className="time">{`Ngày duyệt: ${getDDMMYYYFormat(
                    detail?.fields?.eApprovedByITHeadDate
                  )} - ${getHHmmFormat(
                    detail?.fields?.eApprovedByITHeadDate
                  )}`}</div>
                )}
            </div>
          </div>
        )}

        {/*BƯỚC 4 */}
        {!isNoiBai(detail?.fields?.eDepartment) && (
          <div className="item">
            {getStatus(detail?.fields?.eAssigneeStatus) ===
              requestStatus.approved && (
              <div className={`step approved`}>
                <FontFa name="faCheck" />
              </div>
            )}

            {getStatus(detail?.fields?.eAssigneeStatus) ===
              requestStatus.rejected && (
              <div className={`step rejected`}>
                <FontFa name="faBan" />
              </div>
            )}

            {getStatus(detail?.fields?.eAssigneeStatus) ===
              requestStatus.submitted && (
              <div className={`step waiting`}>
                <FontFa name="faCheck" />
              </div>
            )}

            <div className="content">
              <div className="rank">
                <h6>Tổng Giám đốc</h6>
              </div>
              <div className="title">
                {
                  getEmployeeDetail(
                    detail?.fields?.eAssignee,
                    employees,
                    softwares
                  )?.[0]?.Title
                }
              </div>
              <div className="title">
                {
                  getEmployeeDetail(
                    detail?.fields?.eAssignee,
                    employees,
                    softwares
                  )?.[0]?.eMail
                }
              </div>
              {(detail?.fields?.eAssigneeStatus === requestStatus.approved ||
                detail?.fields?.eAssigneeStatus ===
                  requestStatus.rejected) &&
                detail?.fields?.eAssigneeStatusDate && (
                  <div className="time">{`Ngày duyệt: ${getDDMMYYYFormat(
                    detail?.fields?.eAssigneeStatusDate
                  )} - ${getHHmmFormat(
                    detail?.fields?.eAssigneeStatusDate
                  )}`}</div>
                )}
            </div>
          </div>
        )}
      </div>
    </Box>
  );
};
